import { render, staticRenderFns } from "./UiCalendarControls.vue?vue&type=template&id=48960d16"
import script from "./UiCalendarControls.vue?vue&type=script&lang=js"
export * from "./UiCalendarControls.vue?vue&type=script&lang=js"
import style0 from "./UiCalendarControls.vue?vue&type=style&index=0&id=48960d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports